import css from "../../css/listing/features.module.css";

import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import {
    FEATURE_BOOL_FIELDS,
    FEATURE_ARRAY_DATA,
    hasFeature,
} from "../../service/listing";

import checkIcon from "../../static/icons/check.png";
import uncheckIcon from "../../static/icons/cross.png";

const Features = (props) => {
    const { data } = props;
    const { features } = data;

    let i = 1;
    let mainFeatures = [];

    for (let f of FEATURE_BOOL_FIELDS) {
        mainFeatures.push(
            <div key={"feature_" + i++} className={css.checkItem}>
                <div className={css.icon}>
                    {hasFeature(data[f.name]) ? (
                        <Image src={checkIcon} alt={f.label} />
                    ) : (
                        <Image src={uncheckIcon} alt={f.label} />
                    )}
                </div>
                <div className={css.label}>{f.label}</div>
            </div>
        );
    }

    let dataFeatures = [];

    if (features) {
        for (let f of FEATURE_ARRAY_DATA) {
            if (features[f.name] && features[f.name].length > 0) {
                dataFeatures.push(
                    <div key={"feature_" + i++} className={css.title}>
                        {f.label}
                    </div>
                );

                for (let fLabel of features[f.name]) {
                    dataFeatures.push(
                        <div key={"feature_" + i++} className={css.checkItem}>
                            <div className={css.icon}>
                                <Image src={checkIcon} alt={fLabel} />
                            </div>
                            <div className={css.label}>{fLabel}</div>
                        </div>
                    );
                }
            }
        }
    }

    return (
        <>
            {mainFeatures.length > 0 && (
                <div className={css.features}>{mainFeatures}</div>
            )}
            {dataFeatures.length > 0 && (
                <div className={css.features}>{dataFeatures}</div>
            )}
        </>
    );
};

Features.propTypes = {
    data: PropTypes.object.isRequired,
};

export default Features;
